import type { MouseEvent } from "react";
import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { CoverImageOverlay } from "@circle-react-uikit/CoverImageInput/CoverImageOverlay";
import { Loader } from "@circle-react-uikit/Loader";
import { CoverImageWrapper } from "../CoverImageWrapper";

export interface CoverImageWithButtonsProps {
  url?: string;
  isLoading?: boolean;
  onChange?: (event: MouseEvent<HTMLButtonElement>) => void;
  onDelete?: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const CoverImageWithButtons = ({
  url,
  isLoading = false,
  onChange,
  onDelete,
}: CoverImageWithButtonsProps) => (
  <CoverImageWrapper>
    <div
      className={classNames(
        "bg-primary aspect-16/5 relative h-full max-h-[20.625rem] md:mx-auto md:max-w-5xl md:overflow-hidden md:rounded-2xl",
      )}
    >
      {isLoading ? (
        <div className="absolute top-0 m-auto flex h-full w-full">
          <Loader center />
        </div>
      ) : (
        <>
          {url ? (
            <img
              loading="lazy"
              className="h-full w-full object-cover"
              src={url}
              alt=""
            />
          ) : (
            <div className="bg-tertiary h-full w-full" />
          )}
          <CoverImageOverlay
            onDelete={onDelete}
            onChange={onChange}
            removeButtonText={t("remove_cover_image")}
            changeButtonText={
              url ? t("edit_cover_image") : t("add_cover_image")
            }
          />
        </>
      )}
    </div>
  </CoverImageWrapper>
);
